import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { ModalBox } from "../Outer/Modal";
import Table from "react-bootstrap/Table";
import { CloseRounded } from "@mui/icons-material";
import {
  GetWinnerAuction,
  RefreshToken,
  SecondaryMarketAuction,
  SecondaryMarketBidSell,
  SecondaryMarketAnnouncement,
  GetWinnerAuctionData,
  SecondaryMarketAuctionSell,
  SecondryMarketSMgetAuctionById,
} from "../../redux/auth-reducer/auth-service";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import * as icons from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import { Card, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ToastContainer, toast } from "react-toastify";
import { DatePicker, Loader } from "rsuite";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import * as signalR from "@microsoft/signalr";
import { SignalRUrl } from "../../utils/config/config";
import { Context } from "../../redux/Context";
import moment from "moment";

export const Secondary_Market = () => {
  const [data, setData] = useState(false);
  const [auctionWinner, setAuctionWinner] = useState([]);
  const [auctionToSellData, setAuctionToSellData] = useState("");
  const [startingBidToSell, setStartingBidToSell] = useState("");
  const [bidIncrementToSell, setBidIncrementToSell] = useState("");
  const [showView, setShowView] = useState(false);
  // const [hubConnection, setHubConnection] = useState(null);
  const [signalRData, setSignalRData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [searchTextLive, setSearchTextLive] = useState();
  const [searchTextClose, setSearchTextClose] = useState("");
  const [searchTextUpcomingLive, setSearchTextUpcomingLive] = useState("");
  const [BidStatusAuction, setBidStatusAuction] = useState([]);
  const [filterClosedAuction, setFilterClosedAuction] = useState([]);
  const [filterUpcomingLiveAuction, setFilterUpcomingLiveAuction] = useState(
    []
  );
  const [disabled, setDisabled] = useState(false);
  const [dateValid, setDateValid] = useState(true);
  const [dataListRecent, setDataListRecent] = useState([]);
  const { hubConnection } = useContext(Context);
  const [totalRows, setTotalRows] = useState(1);
  const [totalRowsWin, setTotalRowsWin] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [currentPageSell, setCurrentPageSell] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [loading, setLoading] = useState(false);

  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabSellAuction") || 'Live';
  });

  useEffect(() => {
    localStorage.setItem("activeTabSellAuction", key);
  }, [key]);

  const navigate = useNavigate();
  const [regForm, setRegForm] = useState({
    startingBid: "",
    ownerShipSold: "",
    startDate: "",
  });
  const handleClose = () => {
    setShowView(false);
    setDateValid(true);
  };

  const handleShowView = (row) => {
    setShowView(true);

    setAuctionToSellData(row);
  };

  const handlebidIncrementToSell = async (e) => {
    e.preventDefault();
    setBidIncrementToSell(e.target.value);
  };

  const sidebarfun = () => {
    setData(!data);
  };
  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const userId = isUser.userId;

  const handleSell = async (event) => {
    if (!regForm?.startDate) {
      setDateValid(false);
      setValidated(true);
      return;
    } else {
      setDateValid(true);
    }

    // const BidStatusAll = async () => {
    //     await GetWinnerAuction().then((res) => {
    //         const sortedData = res?.data?.data?.dataList.sort((a, b) => new Date(b.date) - new Date(a.date));
    //         sortedData.reverse();
    //         setBidStatusAuction([...sortedData]);
    //     });
    // }
    // BidStatusAll()

    event.preventDefault();

    if (Number(regForm?.startingBid) > 0) {
      const dataList = [
        {
          crudOperationId: true,
          id: 0,
          auctionId: auctionToSellData?.auctionId,
          teamId: auctionToSellData?.teamId,
          teamOwnerId: auctionToSellData?.teamOwnerId,
          bidAmount: auctionToSellData?.bidAmount,
          startingBid: Number(regForm?.startingBid),
          bidIncrement: auctionToSellData?.bidIncrement,
          startDate: regForm?.startDate,
          maxOwnerShip: auctionToSellData?.maxOwnerShip,
          ownerShipSold: Number(regForm?.ownerShipSold),
        },
      ];

      await SecondaryMarketBidSell(dataList).then((res) => {
        if (res?.data?.status == true) {
          setShowView(false);
          toast.success(res?.data?.message);
          setAuctionToSellData("");
          setStartingBidToSell("");
          setBidIncrementToSell("");
        } else {
          toast.error(res?.data?.message);
        }
      });
    }
  };

  /**************/
  // useEffect(() => {

  //     const GetSecoderyAuction = async () => {
  //         await SecondryMarketSMgetAuctionById().then((response) => {

  //         })
  //     }
  //     GetSecoderyAuction();

  // }, [])

  /**************/

  const getAdminData = async (data) => {
    setLoading(true);
    try {
      const response = await SecondaryMarketAuctionSell(data); // Call your API function
      setLoading(false);
      if (response?.data) {
        setAuctionWinner(
          response?.data?.data?.dataList.filter(
            (event) => event.status === "Live"
          ) || []
        );
        // Set the item list

      //Pandey pagination in sell Auction
      setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  // useEffect(() => {
  //   const data = {
  //     PageNumber: currentPageSell,
  //     PageSize: perPage,
  //     SortOrder: false,
  //   };
  //   getAdminData(data); // Fetch data when currentPage changes
  // }, [currentPageSell]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextLive ? searchTextLive : "",
      // SortColumn: searchTextLive  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: newPerPage,
      SortOrder: false,
    };
    getAdminData(data);

    setPerPage(newPerPage); // Update items per page
      currentPageSell(1)   // Reset to first page when items per page changes
    
  };

  const handlePerPageChange1 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextUpcomingLive ? `Closed,Archive, ${searchTextUpcomingLive}` : "Closed,Archive",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: newPerPage,
      SortOrder: false,
    };
    BidStatusAll(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPageClosed(1); // Reset to first page when items per page changes
  };

  const handlePerPageChange2 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      SearchTerm: searchTextUpcomingLive ? `Live,Upcoming,Paused, ${searchTextUpcomingLive}` : "Live,Upcoming,Paused",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    BidStatusAll(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPageSell < Math.ceil(totalRows)) {
      setCurrentPageSell((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handleNextPage1 = () => {
    if (currentPage < Math.ceil(totalRowsWin)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handleNextPageClosed = () => {
    if (currentPageClosed < Math.ceil(totalRowsWin)) {
      setCurrentPageClosed((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPageSell > 1) {
      setCurrentPageSell((prevPage) => prevPage - 1); // Go to previous page
    }
  };
  const handlePreviousPage1 = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };
  const handlePreviousPageClosed = () => {
    if (currentPageClosed > 1) {
      setCurrentPageClosed((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handelForm = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
  };

  const handelDate = (e) => {
    setDateValid(true);
    setRegForm({
      ...regForm,
      startDate: e,
    });
  };

  const btnplacebid = (item) => {
    navigate(`/Player/SecodaryPlaceBid?auctionId`, { state: item });
  };
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  const column = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
    },
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },

    {
      name: "Bid Amount",
      selector: (row) => row.bidAmount,
      sortable: true,
    },
    {
      name: "Max Owner Ship",
      selector: (row) => row.maxOwnerShip,
      sortable: true,
    },
    {
      name: "Bid Increment",
      selector: (row) => row.bidIncrement,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <Button
          // disabled={row.status != "Closed" ? true : false}
          onClick={() => handleShowView(row)}
        >
          Sell
        </Button>
      ),
      sortable: true,
    },
  ];

  // const handleSearchLive = (e) => {
  //   setSearchTextLive(e.target.value);
  // };

  const filteredDataAuctionWinner = searchTextLive
    ? auctionWinner.filter((item) => {
        return (
          item.status.toLowerCase() === "live" &&
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextLive.toLowerCase()) || item?.teamName
            ?.toLowerCase()
            .includes(searchTextLive.toLowerCase())
        );
      })
    : auctionWinner;

  var tempTimeOut = false;

  useEffect(() => {
    let isListLive = [...BidStatusAuction];

    clearInterval(tempTimeOut);
    if (isListLive?.length > 0) {
      var num = new Date().getTime();
      let now = moment().utc();
      tempTimeOut = setInterval(() => {
        let remaingData = isListLive
          .sort(function (a, b) {
            return a.teamId - b.teamId;
          })
          .sort(function (a, b) {
            return new Date(a.startDate) - new Date(b.startDate);
          })
          .filter(function (a) {
            // now.isAfter(a.startDate) &&
            if (a.status == "Upcoming") {
              return { ...a, recievedAt: new Date() };
            } else if (now.isAfter(a.startDate) && a.status == "Live") {
              let remainingtimer = moment()
                .add(a?.remainingBidTime?.split(":")[0], "minutes")
                .add(a?.remainingBidTime?.split(":")[1], "seconds")
                .format();
              return { ...a, recievedAt: remainingtimer };
            }
            return a;
            // return (num - new Date(a.startDate + 'Z').getTime()) < 0; })
          });

        setBidStatusAuction(remaingData);

        // let liveFound = remaingData?.filter((event) => event.status === "Live");

        // liveFound
      }, 1000);
    }

    return () => {
      clearInterval(tempTimeOut);
    };
  }, [BidStatusAuction]);

  useEffect(() => {
    if (hubConnection) {
      // Listen for messages from the SignalR hub
      hubConnection.on("ReceiveSMBidStatus", (data) => {
        // setSignalRData(data);
        if (data?.length > 0) {
          setBidStatusAuction((prev) => {
            let newData = prev.map((item) => {
              let isLiveNow = data.filter(
                (e) =>
                  e.auctionId == item.auctionId &&
                  e.teamId == item.teamId &&
                  e.auctionLevel == item.auctionLevel &&
                  e.status == "Live"
              );

              let isPresentList = data.filter(
                (e) =>
                  e.auctionId == item.auctionId &&
                  e.teamId == item.teamId &&
                  e.auctionLevel == item.auctionLevel
              );

              if (isLiveNow?.length > 0) {
                let remainingtimer = moment()
                  .add(isLiveNow[0]?.remainingBidTime?.split(":")[0], "minutes")
                  .add(isLiveNow[0]?.remainingBidTime?.split(":")[1], "seconds")
                  .format();
                return {
                  ...item,
                  status:
                    isLiveNow[0].status == "Live" &&
                    isLiveNow[0].remainingBidTime == "00:00"
                      ? "Closed"
                      : "Live",
                  totalPoolAmount: isLiveNow[0]?.totalPoolAmount,
                  recievedAt: remainingtimer,
                };
              } else if (isPresentList[0]?.status == "Paused") {
                return { ...item, status: "Paused" };
              } else if (item.status == "Live") {
                return { ...item, status: "Closed", recievedAt: new Date() };
              } else if (isPresentList?.length > 0) {
                return {
                  ...item,
                  status: isPresentList[0].status,
                  totalPoolAmount: isLiveNow[0]?.totalPoolAmount,
                };
              }
              return { ...item, recievedAt: new Date() };
            });
            // setTimer(newData.filter((event) => event.status === "Upcoming" || event.status === "Live" || event.status === "Paused"))
            return newData;
          });
        }
      });

      hubConnection.on("ReceiveCurrentSMBid", (data) => {
        data.map((oldRest) => {
          setBidStatusAuction((prev) => {
            let newData = prev.map((item) => {
              if (
                oldRest.auctionId == item.auctionId &&
                oldRest.teamId == item.teamId &&
                oldRest.auctionLevel == item.auctionLevel &&
                oldRest.status == "Live"
              ) {
                let remainingtimer = moment()
                  .add(oldRest?.remainingBidTime?.split(":")[0], "minutes")
                  .add(oldRest?.remainingBidTime?.split(":")[1], "seconds")
                  .format();
                return { ...item, recievedAt: remainingtimer };
              }
              return item;
            });
            return newData;
          });
          // setDataListRecent(newData)
        });
      });

      hubConnection.on("GetRecentSMAuction", (data) => {
        //     setBidStatusAuction((prev) => {
        //         let newData = prev.map((item) => {
        //             let filterData = data.filter((e) => e?.auctionId == item?.auctionId && e?.teamId == item?.teamId && e.auctionLevel == item.auctionLevel)
        //             if (filterData?.length > 0) {
        //                 return { ...filterData[0], status : "Upcoming", recievedAt: new Date() }
        //             }
        //             return item
        //         })
        //         return newData
        //     })

        // });
        let newData = data.map((e) => {
          return { ...e, recievedAt: new Date() };
        });

        setBidStatusAuction((prev) => [...prev, ...newData]);
      });

      // Cleanup the event listener on unmount
      return () => {
        hubConnection.off("ReceiveSMBidStatus");
        hubConnection.off("ReceiveCurrentSMBid");
        hubConnection.off("GetRecentSMAuction");
      };
    }
  }, [hubConnection]);

  function addLiveTeam(data) {
    if (!data) return;
    if (data?.status != "Upcoming") return;

    setBidStatusAuction((prev) => {
      let newData = prev.map((item) => {
        if (
          data.auctionId == item.auctionId &&
          data.teamId == item.teamId &&
          item.status != "Live" &&
          data.auctionLevel == item.auctionLevel
        ) {
          let remainingtimer = moment().add(item.bidTime, "minutes").format();
          return { ...item, status: "Live", recievedAt: remainingtimer };
        }
        //  else if(data.auctionId == item.auctionId && data.teamId == item.teamId){
        //   return { ...item, status: "Closed" }
        //   // return { ...item }
        //  }
        return item;
      });

      // setTimer(newData.filter((event) => event.status === "Upcoming" || event.status === "Live" || event.status === "Paused"))
      return newData;
    });
  }

  function addLiveToNextTeam(data) {
    if (data.status != "Live") return;

    setBidStatusAuction((prev) => {
      let newData = prev.map((item) => {
        if (
          data.auctionId == item.auctionId &&
          data.teamId == item.teamId &&
          data.auctionLevel == item.auctionLevel
        ) {
          return { ...item, status: "Closed" };
          // return { ...item }
        }
        return item;
      });

      // setTimer(newData.filter((event) => event.status === "Upcoming" || event.status === "Live" || event.status === "Paused"))
      return newData;
    });
    window.location.reload();
  }

  function addZero(num) {
    if (num < 10) {
      return `0${num}`;
    }
    return num;
  }

  function getExectTime(end, nextItemStart) {
    let now = moment();
    var diffDays =
      nextItemStart.status == "Upcoming"
        ? new Date(nextItemStart.startDate + "Z").getTime() -
          new Date().getTime()
        : new Date(end).getTime() - new Date().getTime();

    var minutes = Math.abs(parseInt(diffDays / (1000 * 60)));
    let allAuctionBid = BidStatusAuction.filter(
      (e) => e.auctionId == nextItemStart.auctionId
    ).sort(function (a, b) {
      return a.teamId - b.teamId;
    });
    let isAnyLive = allAuctionBid.some((e) => e.status == "Live");

    var seconds = parseInt(diffDays / 1000);

    if (
      !isAnyLive &&
      nextItemStart.status == "Upcoming" &&
      minutes == 0 &&
      new Date(diffDays).getSeconds() == 0
    ) {
      addLiveTeam(nextItemStart);
    } else if (
      diffDays &&
      minutes == 0 &&
      new Date(diffDays).getSeconds() == 0 &&
      nextItemStart.status != "Upcoming"
    ) {
      addLiveToNextTeam(nextItemStart);
    }

    return nextItemStart.status == "Live"
      ? `${minutes > 0 ? addZero(minutes) : "00"}:${
          new Date(diffDays).getSeconds() > 0
            ? addZero(new Date(diffDays).getSeconds())
            : "00"
        }`
      : "";
  }

  const columns = [
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },
    {
      name: "Contest Name",
      selector: (row) => row.tournamentName,
      sortable: true,
    },
    {
      name: "Sport Name",
      selector: (row) => row.sportName,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
      width: "200px",
    },

    {
      name: "Bid Time Limit",
      selector: (row) => row.bidTime,
      sortable: true,
    },

    {
      name: "Starting Bid",
      selector: (row) => row.startingBid,
      sortable: true,
    },
    {
      name: "Bid Increment",
      selector: (row) => row.bidIncrement,
      sortable: true,
    },

    {
      name: "Bid Status",
      selector: (row) =>
        row.status === "Upcoming" ? (
          <>
            <span style={{ color: "#f9c114" }}>
              Upcoming {getExectTime(row.recievedAt, row)}
            </span>
          </>
        ) : row.status === "Live" ? (
          <>
            <span style={{ color: "#043bc7" }}>
              Live {getExectTime(row.recievedAt, row)}
            </span>
          </>
        ) : row.status === "Closed" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : row.status === "Paused" ? (
          <>
            <span style={{ color: "red" }}>Paused</span>
          </>
        ) : row.status === "Archive" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : (
          <>
            <span style={{ color: "green" }}>Play</span>
          </>
        ),

      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => row.createdByName,
      sortable: true,
    },
    {
      name: "",
      selector: (row) => (
        <>
          {row.status === "Live" ? (
            <div className="sticky-tab">
              <button
                // className="tablebtn placebid disable"
                className={
                  row.createdById === userId
                    ? "tablebtn placebid disable"
                    : "tablebtn placebid"
                }
                disabled={row.createdById === userId}
                onClick={() => btnplacebid(row)}
              >
                Place Bid
              </button>{" "}
            </div>
          ) : (
            <div className="sticky-tab">
              <button
                className="tablebtn placebid disable"
                disabled
                onClick={() => btnplacebid(row)}
              >
                Place Bid
              </button>
            </div>
          )}
        </>
      ),
      sortable: true,
      cellClass: "fixed-column",
    },
  ];

  const Columns_SM_Winners = [
    {
      name: "Team Name",
      selector: (row) => row.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row.auctionName,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;
        const localTime = convertUTCToLocalTime(row?.startDate + "Z");
        const dayjsDate = dayjs(localTime);
        if (!dayjsDate.isValid()) {
          return <p>Invalid date</p>;
        }
        const formattedDate = dayjsDate.format("MM/DD/YYYY");
        const timePart = dayjsDate.format("hh:mm:ss A");
        return (
          <p>
            {formattedDate}, {timePart}
          </p>
        );
      },
      sortable: true,
    },

    {
      name: <strong>End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;
        const localTime = convertUTCToLocalTime(row?.endDate + "Z");
        const dayjsDate = dayjs(localTime);
        if (!dayjsDate.isValid()) {
          return <p>Invalid date</p>;
        }
        const formattedDate = dayjsDate.format("MM/DD/YYYY");
        const timePart = dayjsDate.format("hh:mm:ss A");
        return (
          <p>
            {formattedDate}, {timePart}
          </p>
        );
      },
      sortable: true,
    },

    {
      name: "Bid Amount",
      selector: (row) => row.bidTime,
      sortable: true,
    },

    {
      name: "Bid Status",
      selector: (row) =>
        row.status === "Upcoming" ? (
          <>
            <span style={{ color: "#f9c114" }}>Upcoming</span>
          </>
        ) : row.status === "Live" ? (
          <>
            <span style={{ color: "#043bc7" }}>Live</span>
          </>
        ) : row.status === "Closed" ? (
          <>
            <span style={{ color: "red" }}>Closed</span>
          </>
        ) : row.status === "Paused" ? (
          <>
            <span style={{ color: "red" }}>Paused</span>
          </>
        ) : (
          <>
            <span style={{ color: "green" }}>Play</span>
          </>
        ),

      sortable: true,
    },
  ];

  const handleSearchClose = (e) => {
    setSearchTextClose(e.target.value);
  };
  // const handleSearchUpcomingLive = (e) => {
  //   setSearchTextUpcomingLive(e.target.value);
  // };

  const filteredDataUpcomingLiveAuction = searchTextUpcomingLive
    ? filterUpcomingLiveAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.sportsName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
          item?.status
            .toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase())
        );
      })
    : filterUpcomingLiveAuction;

  const filteredDataCloseAuction = searchTextClose
    ? filterClosedAuction.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.teamName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item.sportsName
            ?.toLowerCase()
            .includes(searchTextClose?.toLowerCase()) ||
          item?.createdByName
            ?.toLowerCase()
            .includes(searchTextClose.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchTextClose?.toLowerCase())
        );
      })
    : filterClosedAuction;

  const filterListData = useMemo(() => {
    let allList = BidStatusAuction.filter((item) => {
      return searchTextUpcomingLive?.length > 0
        ? item?.auctionName
            ?.toLowerCase()
            .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.teamName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.sportsName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.createdByName
              ?.toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
            item?.status
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) || 
             item?.tournamentName
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase()) ||
              item?.sportName
              .toLowerCase()
              .includes(searchTextUpcomingLive?.toLowerCase())
        : item;
    });

    let liveOnTop = allList.filter((event) => event.status === "Live");
    let otherLeft = allList.filter((event) => event.status !== "Live");

    return [...liveOnTop, ...otherLeft];
  }, [BidStatusAuction, searchTextUpcomingLive]);

  // const filteredDataSMWinners = searchTextClose ? filterClosedAuction.filter((item) => {
  //     return item?.auctionName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item?.teamName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item.sportsName?.toLowerCase().includes(searchTextClose?.toLowerCase()) || item?.createdByName?.toLowerCase().includes(searchTextClose.toLowerCase()) || item?.status?.toLowerCase().includes(searchTextClose?.toLowerCase())
  // }) : filterClosedAuction;

  useEffect(() => {
    const filterUpcomingsLivesAuction = (eventArray) => {
      return eventArray?.filter(
        (event) => event.status === "Upcoming" || event.status === "Live"
      );
    };

    setFilterUpcomingLiveAuction(filterUpcomingsLivesAuction(BidStatusAuction));

    const filterClosesAuction = (eventArray) => {
      return eventArray?.filter(
        (event) => event.status === "Closed" || event.status === "Archive"
      );
    };
    setFilterClosedAuction(filterClosesAuction(BidStatusAuction));
  }, [signalRData, BidStatusAuction]);

  const BidStatusAll = async (data) => {
    setLoading(true);
    try {
      const response = await GetWinnerAuctionData(data); // Call your API function
      //   if (response?.data) {
      //    setAuctionWinner(response?.data?.data?.dataList.filter((event) => event.status === "Live") || [])
      //     // Set the item list
      //     setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      //   }
      setLoading(false);
      const sortedData = response?.data?.data?.dataList
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .map((e) => {
          let remainingtimer =
            e.status == "Upcoming"
              ? new Date()
              : moment()
                  .add(e?.remainingBidTime?.split(":")[0], "minutes")
                  .add(e?.remainingBidTime?.split(":")[1], "seconds")
                  .format();
          return {
            ...e,
            recievedAt: remainingtimer,
            status:
              e.status == "Live" && e.remainingBidTime == "00:00"
                ? "Closed"
                : e.status,
          };
        });
      sortedData.reverse();
      setBidStatusAuction([...sortedData] || []);
      const liveUpcommingPaginationData =  response?.data?.data?.dataList?.filter((ele) => ele.status === 'Live' || 'Upcoming' )

      setTotalRowsWin(response.data.data.totalPageSize || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    setLoading(true);
    if(key === "Live"){
      const data = {
      SearchTerm: searchTextUpcomingLive ? `Live,Upcoming,Paused, ${searchTextUpcomingLive}` : "Live,Upcoming,Paused",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
      BidStatusAll(data); // Fetch data when currentPage changes

       const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          BidStatusAll(data); // Call the function again when the page becomes visible
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };

    }else if(key === 'Closed'){
       const data1 =  {
      SearchTerm: searchTextUpcomingLive ? `Closed,Archive, ${searchTextUpcomingLive}` : "Closed,Archive",
      SortColumn: searchTextUpcomingLive  !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: perPage,
      SortOrder: false,
    };
      BidStatusAll(data1);

       const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          BidStatusAll(data1); // Call the function again when the page becomes visible
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };

    }else if(key === 'Sell Auctions'){
      const data = {
      SearchTerm: searchTextLive ? searchTextLive : "",
      // SortColumn: searchTextLive  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: perPage,
      SortOrder: false,
    };
    getAdminData(data);
      //  BidStatusAll(data);

       const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
           getAdminData(data); // Call the function again when the page becomes visible
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);

      // Cleanup the event listener on component unmount
      return () => {
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      };

    }else{

    }
  }, [currentPage, currentPageClosed, perPage, key, currentPageClosed, currentPageSell]); // Dependency on currentPage

  // useEffect(() => {
  //   const data = {
  //     PageNumber: currentPageSell,
  //     PageSize: perPage,
  //     SortOrder: false,
  //   };
  //   getAdminData(data); // Fetch data when currentPage changes
  // }, [currentPageSell]);

  // const handleSelect = (k) => {
    // setKey(k);
    // if (k === 'profile') {
    //     const BidStatusAll = async () => {
    //         await GetWinnerAuction().then((res) => {
    //             const sortedData = res?.data?.data?.dataList.sort((a, b) => new Date(b.date) - new Date(a.date));
    //             sortedData.reverse();
    //             setBidStatusAuction([...sortedData]);
    //         });
    //     }
    //     BidStatusAll()
    // }
  // };
  // const clearSearch = () => {
  //   setSearchTextLive("");
  //   setSearchTextClose("");
  //   setSearchTextUpcomingLive("");
  // };

// implement searching functionlity from debounce

const timeoutRef = useRef(null);

  const executeSearch = useCallback((query) => {
    // Replace this console log with your actual data fetching logic (e.g., Axios call, Redux action)
    const data = {
      SearchTerm: query ? `Live,Upcoming,Paused, ${query}` : "Live,Upcoming,Paused",
      SortColumn: query !== "" ? "" : "status",
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };

    const data1 =  {
      SearchTerm: query ? `Closed,Archive, ${query}` : "Closed,Archive",
      SortColumn: query !== "" ? "" : "status",
      PageNumber: currentPageClosed,
      PageSize: perPage,
      SortOrder: false,
    }

     const data3 = {
       SearchTerm: query ? query : "",
      // SortColumn: query  !== "" ? "" : "status",
      PageNumber: currentPageSell,
      PageSize: perPage,
      SortOrder: false,
    };


    if(key === "Live"){
      BidStatusAll(data); // Fetch data when currentPage changes
    }else if(key === 'Closed'){
      BidStatusAll(data1);
    }else if(key === "Sell Auctions"){
      getAdminData(data3);
    }
    console.log("Searching data for:", query);
    // Example: fetchData(query);
  }, [key, currentPage, currentPageClosed, currentPageSell, perPage]); // Include dependencies to ensure latest values

  // The debounced change handler for the input field
  const handleSearchUpcomingLive = (e) => {
    const value = e.target.value;
    if(key  ===  'Sell Auctions'){
      setSearchTextLive(value);
    }else{
    setSearchTextUpcomingLive(value);
    }

    // 1. Clear any previous pending timeouts
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // 2. Set a new timeout
    timeoutRef.current = setTimeout(() => {
      // 3. Call the actual search function after 2000ms (2 seconds)
      executeSearch(value);
    }, 2000);
  };

  // Function to clear the search input immediately
  const clearSearch = () => {
    // Clear any pending timeouts when the input is cleared manually
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setSearchTextLive("");
    setSearchTextClose("");
    setSearchTextUpcomingLive("");
    // Trigger an immediate clear search (or re-fetch all data)
    executeSearch('');
  };


  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <Modal size="lg" show={showView} onHide={handleClose}>
        <Form noValidate validated={validated}>
          <Modal.Header>
            <Modal.Title>Resale Bid</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Form.Group as={Col} md="6 mt-3" controlId="validationCustom02">
                <Form.Label>Auction Name</Form.Label>
                <Form.Control
                  name="firstName"
                  disabled
                  value={auctionToSellData?.auctionName}
                  required
                  type="text"
                  placeholder="Enter your first name"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter First Name.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Team Name</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="teamName"
                    disabled
                    placeholder=" Enter your last name"
                    value={auctionToSellData?.teamName}
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Last Winning Amount</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    disabled
                    name="bidAmount"
                    placeholder=" Enter your last name"
                    value={auctionToSellData?.bidAmount}
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Current OwnerShip</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    disabled
                    name="lastName"
                    placeholder=" Enter your last name"
                    value={auctionToSellData?.maxOwnerShip}
                    aria-describedby="inputGroupPrepend"
                    readOnly
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Bid Increment </Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="lastName"
                    disabled
                    placeholder=" Enter Bid Increment for Sell"
                    value={auctionToSellData?.bidIncrement}
                    aria-describedby="inputGroupPrepend"
                    onChange={(e) => handlebidIncrementToSell(e)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a bid increment.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Sell Ownership</Form.Label>
                <InputGroup hasValidation>
                  <Form.Select
                    onChange={handelForm}
                    name="ownerShipSold"
                    className="select-option"
                    required
                    as="select"
                  >
                    <option value={""}>Select Ownership</option>
                    {auctionToSellData?.maxOwnerShip == 25 ? (
                      <>
                        <option value={"25"}>25%</option>
                      </>
                    ) : auctionToSellData?.maxOwnerShip == 50 ? (
                      <>
                        <option value={"25"}>25%</option>
                        <option value={"50"}>50%</option>
                      </>
                    ) : (
                      <>
                        <option value={"25"}>25%</option>
                        <option value={"50"}>50%</option>
                        <option value={"100"}>100%</option>
                      </>
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Please select a ownership sold.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group
                as={Col}
                md="6 mt-3"
                controlId="validationCustomUsername"
              >
                <Form.Label>Minimum Bid</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control
                    type="text"
                    name="startingBid"
                    placeholder=" Enter minimum bid to sell"
                    required
                    aria-describedby="inputGroupPrepend"
                    onChange={handelForm}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a minimum bid.
                  </Form.Control.Feedback>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} md={6} className="mt-3">
                <Form.Label>Start Bid Date and Time</Form.Label>
                <DatePicker
                  format="MM/dd/yyyy hh:mm:ss aa"
                  showMeridian
                  placeholder="Start Date"
                  disabledDate={(date) =>
                    date < new Date().setHours(0, 0, 0, 0)
                  }
                  name="startDate"
                  className=" Auction-Date"
                  onChange={handelDate}
                  required
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{ display: dateValid ? "none" : "block" }}
                >
                  Please select the date and time.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSell}>
              Bid Sell
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Secondary Market</h1>
          <div className="group_data_table">
            <div className="group_data_table tabs-auction">
              <div className="tabs-box">
                {loading ? (
                  <Loader />
                ) : (
                  <Tabs
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    defaultActiveKey="Sell Auctions"
                    id="auctiontabs"
                    className="mb-0 tab-list-item"
                    justify
                  // onSelect={handleSelect}
                  >
                    <Tab eventKey="Sell Auctions" title="Sell Auctions">
                      <div className="search-input filter auction-filter">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchTextLive}
                          onChange={handleSearchUpcomingLive}
                        />
                        {searchTextLive && (
                          <button className="btn btn-clear" onClick={clearSearch}>
                            <span>&times;</span>{" "}
                            {/* This represents the close icon */}
                          </button>
                        )}
                      </div>

                      {/* <DataTable
                                            title="dfsfd"
                                            columns={column}
                                            data={filteredDataAuctionWinner}
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                            paginationTotalRows={filteredDataAuctionWinner?.length}
                                        /> */}

                      <div>
                        <DataTable
                          columns={column}
                          data={filteredDataAuctionWinner}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPageSell}
                          onChangePage={setCurrentPageSell}
                        />
                        {totalRows >= 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows per page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPageSell === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPageSell} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPageSell >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Tab>

                    <Tab eventKey="Live" title="Live and Upcoming">
                      <div className="auctiontabs auction-closed-status">
                        <div className="search-input filter auction-filter">
                          <input
                            type="text"
                            className="form-control mb-3 mt-3"
                            placeholder="Search..."
                            value={searchTextUpcomingLive}
                            onChange={handleSearchUpcomingLive}
                          />
                          {searchTextUpcomingLive && (
                            <button
                              className="btn btn-clear"
                              onClick={clearSearch}
                            >
                              <span>&times;</span>{" "}
                              {/* This represents the close icon */}
                            </button>
                          )}
                        </div>

                        {/* <DataTable
                                                columns={columns}
                                                data={filterListData?.filter((event) => event.status === "Upcoming" || event.status === "Live")}
                                                pagination
                                                paginationPerPage={10}
                                                defaultSortFieldId={1}
                                                paginationRowsPerPageOptions={[10, 20, 30]}
                                            /> */}

                        <div>
                          <DataTable
                            columns={columns}
                            data={BidStatusAuction.filter(
                              (event) =>
                                event.status === "Upcoming" ||
                                event.status === "Live" ||
                                event.status === "Paused"
                            )}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRowsWin * 10}
                            paginationDefaultPage={currentPage}
                            onChangePage={setCurrentPage}
                          />
                          {totalRowsWin >= 1 && (
                            <Row>
                              <Col md={12} className="text-right">
                                <div className="pagination-controls">
                                  <label>Rows page: </label>
                                  <select
                                    id="itemsPerPage"
                                    value={perPage}
                                    onChange={handlePerPageChange2}
                                  >
                                    {pageOptions.map((option) => (
                                      <option key={option} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>

                                  <Button
                                    onClick={handlePreviousPage1}
                                    disabled={currentPage === 1}
                                  >
                                    <icons.ArrowLeft></icons.ArrowLeft>
                                  </Button>
                                  <span>
                                    {" "}
                                    Page {currentPage} of {totalRowsWin}{" "}
                                  </span>
                                  <Button
                                    onClick={handleNextPage1}
                                    disabled={
                                      currentPage >= Math.ceil(totalRowsWin)
                                    }
                                  >
                                    <icons.ArrowRight></icons.ArrowRight>
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    </Tab>

                    <Tab eventKey="Closed" title="Closed">
                      <div>
                        <div className="auctiontabs">
                          <div className="search-input filter auction-filter">
                            <input
                              type="text"
                              className="form-control mb-3 mt-3"
                              placeholder="Search..."
                              value={searchTextUpcomingLive}
                              onChange={handleSearchUpcomingLive}
                            />
                            {searchTextUpcomingLive && (
                              <button
                                className="btn btn-clear"
                                onClick={clearSearch}
                              >
                                <span>&times;</span>{" "}
                                {/* This represents the close icon */}
                              </button>
                            )}
                          </div>
                          <div>
                            <DataTable
                              columns={columns}
                              data={BidStatusAuction.filter(
                                (event) =>
                                  event.status === "Closed" ||
                                  event.status === "Archive"
                              )}
                              paginationPerPage={perPage}
                              paginationTotalRows={totalRowsWin * 10}
                              paginationDefaultPage={currentPageClosed}
                              onChangePage={setCurrentPageClosed}
                            />
                            {totalRowsWin >= 1 && (
                              <Row>
                                <Col md={12} className="text-right">
                                  <div className="pagination-controls">
                                    <label>Rows page: </label>
                                    <select
                                      id="itemsPerPage"
                                      value={perPage}
                                      onChange={handlePerPageChange1}
                                    >
                                      {pageOptions.map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </select>

                                    <Button
                                      onClick={handlePreviousPageClosed}
                                      disabled={currentPageClosed === 1}
                                    >
                                      <icons.ArrowLeft></icons.ArrowLeft>
                                    </Button>
                                    <span>
                                      {" "}
                                      Page {currentPageClosed} of {totalRowsWin}{" "}
                                    </span>
                                    <Button
                                      onClick={handleNextPageClosed}
                                      disabled={
                                        currentPageClosed >= Math.ceil(totalRowsWin)
                                      }
                                    >
                                      <icons.ArrowRight></icons.ArrowRight>
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
